import React from 'react';
import PlanningItem from '../Domain/PlanningItem.js';
import AuthService from './authService.js';

class PlanningItemService extends React.Component{

    static GetPlanningItems()
    {
        return AuthService  
            .getInstance()
            .CallBackendFunction("/api/PlanningItems/GetPlanningItem");
    }

    
    static GetPlanningItemsByServiceId(orderBy, orderDir, pageNumber, numberOfElements,searchItem)
    {
        let url="/api/PlanningItems/GetPlanningItemsByServiceId/"+searchItem.ServiceId+"?orderBy="+orderBy+"&orderDirection="+orderDir;
        return AuthService  
            .getInstance()
            .CallBackendFunction(url);
    }

    static ConvertDBPlanningItems(PlanningItems)
    {
        var convertedPlanningItems = [];

        PlanningItems.forEach(item => {
            var newItem = new PlanningItem(item);
            convertedPlanningItems.push(newItem);
        });
        
        return convertedPlanningItems;
    }
}

export default PlanningItemService;